import { Injectable } from '@angular/core';

export interface SubMenu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
}
export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
  children: SubMenu[];
}

const MENUITEMS = [
    { state: 'collis', type: 'link', name: 'gestionCollis', icon: 'outgoing_mail' , priv: 'cr_colis', children: []},
    { state: 'bagage', type: 'link', name: 'ajoutebagage', icon: 'business_center' , priv: 'cr_bagage', children: []},
    { state: 'bagage\/autre', type: 'link', name: 'autresentre', icon: 'all_inclusive' , priv: 'cr_recette', children: []},
    { state: 'collis\/mail', type: 'link', name: 'listcollis', icon: 'view_list' , priv: 'rd_colis', children: []},
    { state: 'bagage\/list', type: 'link', name: 'listbagage', icon: 'view_list' , priv: 'rd_bagage', children: []},
    { state: 'bordeaureau', type: 'link', name: 'gestionbordeaureaux', icon: 'content_paste_go' , priv: 'cr_bordereau', children: []},
    { state: 'listbordeaureau', type: 'link', name: 'listbordeaureaux', icon: 'content_paste_search' , priv: 'rd_bordereau', children: []},
    { state: 'free', type: 'link', name: 'freecode', icon: 'shuffle' , priv: 'rd_freeticket', children: []},
    { state: 'session\/usersession', type: 'link', name: 'raportsessions', icon: 'insights' , priv: 'cr_colis', children: []},
    { state: 'session', type: 'link', name: 'raportsession', icon: 'update' , priv: 'rd_session', children: []},

];

@Injectable()
export class MenuItemsEnvoi {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
